import { render } from "./InsuranceAgentsPendingSignupsOverview.vue?vue&type=template&id=93d21c14"
import script from "./InsuranceAgentsPendingSignupsOverview.vue?vue&type=script&lang=js"
export * from "./InsuranceAgentsPendingSignupsOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
